'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFavoriteBorder = function MdFavoriteBorder(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.2 30.9c7.9-7.1 13.2-11.9 13.2-16.8 0-3.3-2.5-5.7-5.9-5.7-2.6 0-5.1 1.6-5.9 3.9h-3.2c-0.8-2.3-3.3-3.9-5.9-3.9-3.4 0-5.9 2.4-5.9 5.7 0 4.9 5.3 9.7 13.2 16.8l0.2 0.2z m7.3-25.9c5.2 0 9.1 4 9.1 9.1 0 6.4-5.6 11.4-14.2 19.3l-2.4 2.1-2.4-2.1c-8.6-7.8-14.2-12.9-14.2-19.3 0-5.1 3.9-9.1 9.1-9.1 2.9 0 5.7 1.4 7.5 3.5 1.8-2.1 4.6-3.5 7.5-3.5z' })
        )
    );
};

exports.default = MdFavoriteBorder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/favorite-border.js
// module id = 2299
// module chunks = 0